import React, { Component, ErrorInfo, ReactNode } from "react";
import { FeatureFlags } from "./constants/LocalServerConstants";
import LmsMessage from "./lms/ui/LmsMessage";

interface IErrorBoundaryProps {
  children: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
  errorMessage?: any;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public state: IErrorBoundaryState = {
    hasError: false
  };

  // eslint-disable-next-line
  public static getDerivedStateFromError(_: Error): IErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (this.state.hasError) {
      const message = error?.message || "Uncaught Error";
      this.setState({ ...this.state, errorMessage: message });
    }
    if (FeatureFlags.IS_DEBUG) {
      console.error("Uncaught error:", error, errorInfo);
    }
  }

  public render() {
    if (this.state.hasError) {
      return <LmsMessage text={this.state.errorMessage}/>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;